import ApartmentIcon from '@mui/icons-material/Apartment'
import { Box, Container, Link, Typography } from '@mui/material'
import CityIcon from './cityIcons'

export interface ExploreHotelLink {
    name: string
    href: string
}

export interface ExploreCity {
    id: string
    iconKey: string
    name: string
    hotels: ExploreHotelLink[]
}

export interface ExploreMoreHotelsProps {
    title: string
    cities: ExploreCity[]
    /** City columns per row on desktop. */
    desktopColumns?: number
}

// Pure presentation: a grid of city columns (4-up on desktop by default), each headed by its
// landmark icon and listing top hotels as external links. Mirrors me-flyin's "Explore more Hotels" section.
const ExploreMoreHotels: React.FC<ExploreMoreHotelsProps> = ({ title, cities, desktopColumns = 4 }) => (
    <Box sx={{ py: { xs: 3, md: 4 } }}>
        <Container maxWidth="xl" sx={{ px: { xs: 2, md: 3 } }}>
            <Typography component="h2" variant="h5" sx={{ fontWeight: 700, color: 'text.primary', fontSize: '1.25rem', mb: 3 }}>
                {title}
            </Typography>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: `repeat(${desktopColumns}, 1fr)` },
                    gap: { xs: 3, md: 4 }
                }}
            >
                {cities.map(city => (
                    <Box key={city.id}>
                        <CityIcon iconKey={city.iconKey} size={48} />
                        <Typography sx={{ fontSize: '1.125rem', fontWeight: 600, color: 'textColors.primary', mt: 1, mb: 3 }}>
                            {city.name}
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                            {city.hotels.map(hotel => (
                                <Link
                                    key={hotel.name}
                                    href={hotel.href}
                                    target="_blank"
                                    rel="noopener"
                                    underline="none"
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        gap: 1,
                                        color: '#2E3338',
                                        '&:hover': { color: 'primary.main' }
                                    }}
                                >
                                    <ApartmentIcon sx={{ fontSize: 18, mt: '1px', flexShrink: 0, color: 'textColors.disabled' }} />
                                    <Typography sx={{ fontSize: '0.875rem', color: 'inherit', lineHeight: 1.35 }}>
                                        {hotel.name}
                                    </Typography>
                                </Link>
                            ))}
                        </Box>
                    </Box>
                ))}
            </Box>
        </Container>
    </Box>
)

export { ExploreMoreHotels }
export default ExploreMoreHotels
